import { Card, ValueChart } from '@opositandopn/ui';
import classnames from 'classnames';

import { ValueCardProps } from './ValueCard.types';

import styles from './ValueCard.module.scss';

function ValueCard({
  className,
  icon,
  title,
  value,
  trending,
  loading,
  tooltip,
  format,
  suffix,
}: ValueCardProps) {
  return (
    <Card
      icon={icon}
      title={title}
      className={classnames(styles['main'], className)}
      loading={loading}
      tooltip={tooltip}
    >
      <ValueChart
        className={styles['value-chart']}
        value={value}
        trending={trending}
        format={format}
        suffix={suffix}
      />
    </Card>
  );
}

export { ValueCard };
